import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export type ExtraCostsSettingsInfoTextMode =
	| "ICC_ONLY"
	| "FINDER_ONLY"
	| "USED_CAR_OFFER_ONLY"
	| "FINDER_AND_USED_CAR_OFFER"
	| "NONE"

export const getExtraCostsSettingsInfoTextMode = (key: MarketplaceKey): ExtraCostsSettingsInfoTextMode => {
	switch (key) {
		case "de":
			return "FINDER_AND_USED_CAR_OFFER"
		case "au":
			return "ICC_ONLY"
		case "ch":
		case "fr":
			return "USED_CAR_OFFER_ONLY"
		case "nl":
			return "ICC_ONLY"
		case "us":
			return "FINDER_ONLY"
		default:
			return "NONE"
	}
}
